// Section — content card with a small uppercase header.
// Used to wrap tables / charts inside a ReportShell body so they share
// the same "card" visual language as FilterBar / KpiStrip.
import React from 'react'
import { theme as defaultTheme, T } from './tokens'

export default function Section({
  title, subtitle, right, children,
  padded = false,            // when true, body gets 16px padding (table/chart fills the body, so default false)
  theme = defaultTheme,
}) {
  return (
    <div style={{
      background: theme.surface, border: `1px solid ${theme.border}`,
      borderRadius: 10, overflow: 'hidden',
    }}>
      {(title || right) && (
        <div style={{
          display: 'flex', alignItems: 'center', gap: 12,
          padding: '12px 16px',
          borderBottom: `1px solid ${theme.border}`,
          background: theme.bgSub,
          fontFamily: T.fontUI,
        }}>
          <div style={{ flex: 1, minWidth: 0 }}>
            {title && (
              <div style={{
                fontSize: 13, fontWeight: 600, color: theme.text,
                letterSpacing: -0.1,
              }}>{title}</div>
            )}
            {subtitle && (
              <div style={{
                fontSize: 11.5, color: theme.textSub, marginTop: 2,
              }}>{subtitle}</div>
            )}
          </div>
          {right && <div>{right}</div>}
        </div>
      )}
      <div style={{ padding: padded ? 16 : 0 }}>
        {children}
      </div>
    </div>
  )
}
